<!-- splash screen -->
<div #splashScreen class="splash-screen">
	<img src="./assets/images/canvas-dark.svg" alt="Logo" />
</div>
